module.exports = __webpack_public_path__ + "media/images/logout-c2a33601da97b4648449b9650d0e9c52.gif";